module.exports = __webpack_public_path__ + "img/certificate_icon.7e330952.svg";